export const CycleInstanceStatus = {
    DRAFT: 'Draft',
    ACTIVE: 'Active',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
    LAUNCHED: 'Launched',
} as const;

export type CycleInstanceStatusValue =
    (typeof CycleInstanceStatus)[keyof typeof CycleInstanceStatus];

export const ReviewType = {
    SELF_EVALUATION: 'SelfEvaluation',
    EVALUATION_360: 'Evaluation360',
    MANAGER_EVALUATION: 'ManagerEvaluation',
} as const;

export type ReviewTypeValue = (typeof ReviewType)[keyof typeof ReviewType];
